export default __webpack_public_path__ + "static/media/v04.99279131.jpg";